import { z } from 'zod';
import { carNoValPartial, egPhone, passwordRegex } from '../utils/util';

// Zod 스키마 정의
export const joinSchema = z
  .object({
    passid: z
      .string()
      .nonempty({ message: '차량번호를 입력해주세요.' })
      .refine(carNoValPartial, 'test'),
    password: z
      .string()
      .min(8, { message: '비밀번호는 최소 8자입니다.' })
      .regex(passwordRegex, '비밀번호는 영문 + 숫자를 조합해야 합니다.'),
    passwordConfirm: z
      .string()
      .min(8, { message: '비밀번호 확인을 입력해주세요.' }),
    phone: z
      .string()
      .min(10, { message: '휴대폰 번호는 최소 10자리입니다.' })
      .max(13, { message: '최대 11자까지 입력 가능합니다.' }),
    registrationFile: z
      .instanceof(File, { message: '자동차 등록증을 업로드해주세요.' })
      .nullable()
      .refine((file) => file !== null, {
        message: '자동차 등록증을 업로드해주세요.',
      }), // 파일 검증
  })
  .refine((data) => data.password === data.passwordConfirm, {
    path: ['passwordConfirm'],
    message: '비밀번호가 일치하지 않습니다.',
  });

// Zod 스키마 정의
export const joinCompanySchema = z
  .object({
    passid: z.string().nonempty({ message: '아이디를 입력해주세요.' }),
    password: z.string().min(8, { message: '비밀번호는 최소 8자입니다.' }),
    passwordConfirm: z
      .string()
      .min(8, { message: '비밀번호 확인을 입력해주세요.' }),
    phone: z
      .string()
      .min(10, { message: '휴대폰 번호는 최소 10자리입니다.' })
      .max(13, { message: '최대 11자까지 입력 가능합니다.' }),
    registrationFile: z
      .instanceof(File, { message: '등록증 파일을 업로드해주세요.' })
      .nullable()
      .refine((file) => file !== null, {
        message: '등록증 파일을 업로드해주세요.',
      }), // 파일 검증
    name: z.string().nonempty({ message: '기업명을 입력해주세요.' }),
    address: z.string().nonempty({ message: '주소를 입력해주세요.' }),
    detail: z.string().nonempty({ message: '상세 주소를 입력해주세요.' }),
    charge: z.string().nonempty({ message: '담당자를 입력해주세요.' }),
    position: z.string().nonempty({ message: '직책을 입력해주세요.' }),
  })
  .refine((data) => data.password === data.passwordConfirm, {
    path: ['passwordConfirm'],
    message: '비밀번호가 일치하지 않습니다.',
  });
